/* Helper function to capitalize names */
function capitalizeName(name) {
  if (!name) return '';
  return name.toLowerCase().split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join(' ');
}

/** Stored on partnerInfo: linked via Shopify account API vs session (lookup, URL, cart, cookie). */
const PARTNER_ATTRIBUTION_KEY = '_partner_attribution_source';
const PARTNER_ATTRIBUTION_SHOPIFY_ACCOUNT = 'shopify_account_api';
const PARTNER_ATTRIBUTION_SESSION = 'session';

/**
 * Shared GA/dataLayer emitter for partner journey events.
 * Keeps payload compact and avoids PII (no raw search text/email).
 */
function emitPartnerAnalytics(eventName, payload) {
  if (!eventName) return;
  try {
    const eventPayload = Object.assign(
      { partner_surface: 'unknown' },
      payload || {}
    );
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(
      Object.assign(
        {
          event: eventName,
          partner_locale: document.documentElement ? (document.documentElement.lang || '') : '',
          partner_path: window.location ? window.location.pathname : '',
          partner_is_logged_in: !!(typeof KROWN !== 'undefined' && KROWN.customerId)
        },
        eventPayload
      )
    );
  } catch (e) {}
}

function withSessionPartnerAttribution(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  return Object.assign({}, obj, { [PARTNER_ATTRIBUTION_KEY]: PARTNER_ATTRIBUTION_SESSION });
}

function getPartnerAttributionSource(partnerObj) {
  if (partnerObj && typeof partnerObj === 'object' && partnerObj[PARTNER_ATTRIBUTION_KEY]) {
    return partnerObj[PARTNER_ATTRIBUTION_KEY];
  }
  try {
    const raw = localStorage.getItem('partnerInfo');
    if (raw) {
      const p = JSON.parse(raw);
      if (p && p[PARTNER_ATTRIBUTION_KEY]) return p[PARTNER_ATTRIBUTION_KEY];
    }
  } catch (e) {}
  return PARTNER_ATTRIBUTION_SESSION;
}

/** Header "Find a Partner" links (desktop + mobile). */
function setHeaderFindPartnerNavVisible(show) {
  var on = !!show;
  document.querySelectorAll('.header-partner-info-container').forEach(function (el) {
    el.classList.toggle('display-none', !on);
  });
  document.querySelectorAll('.header-partner-info-container-mobile').forEach(function (el) {
    el.classList.toggle('display-none', !on);
  });
}

/* Function to add partner details
 * @param {object} response - Partner API payload
 * @param {boolean} [skipInitSelectedPartner] - When true, do not call initSelectedPartner() (avoids async race when addPartnerBlock is invoked right after a list selection; partner-lookup already calls addSelectedPartnerBlock). */
function addPartnerBlock(response, skipInitSelectedPartner) {
    const firstName = response.FirstName;
    const lastName = response.LastName;
    if (response.hide_partner_info !== "Yes") {
        document.querySelectorAll('.partner-container').forEach(elm => elm.classList.remove("display-none"));
        setHeaderFindPartnerNavVisible(false);
        document.querySelectorAll('.partner-info-container').forEach(elm => {
            // Save the icon if it exists before overwriting innerHTML
            const iconSpan = elm.querySelector('.partner-market-icon');
            const iconHTML = iconSpan ? iconSpan.outerHTML : '';
            elm.innerHTML = capitalizeName(firstName) + ' ' + capitalizeName(lastName);
            // Re-add the icon after setting the partner name
            if (iconHTML) {
                elm.insertAdjacentHTML('beforeend', iconHTML);
            } else if (KROWN.settings.partner_info_modal) {
                // Icon doesn't exist but partner_info_modal is enabled - create it
                // Determine if it's desktop or mobile container
                const partnerContainer = elm.closest('.partner-container');
                const isMobile = partnerContainer && partnerContainer.classList.contains('partner-info-mobile');
                const iconId = isMobile ? 'headerPartnerModalDisplayMobile' : 'headerPartnerModalDisplay';
                
                // Read typography after DOM update; defer one frame so getComputedStyle matches painted styles.
                const readStyles = () => {
                    const containerStyle = window.getComputedStyle(elm);
                    const color = containerStyle.color;
                    const fontSize = containerStyle.fontSize;
                    const fontWeight = containerStyle.fontWeight;

                    const iconElement = document.createElement('span');
                    iconElement.className = 'partner-market-icon';
                    iconElement.id = iconId;
                    iconElement.style.cssText = `color: ${color}; font-size: ${fontSize}; font-weight: ${fontWeight}; display: inline-flex; margin-left: 4px; cursor: pointer;`;

                    // Explicit fill matches theme-symbols `arrow-right-icon` — avoid fill="currentColor" here:
                    // right after innerHTML, computed color can still be wrong until reflow (looks fine after reload).
                    iconElement.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.476 10.8333H4.16634C3.7061 10.8333 3.33301 10.4603 3.33301 10C3.33301 9.53978 3.7061 9.16668 4.16634 9.16668H13.476L10.1845 5.87523C9.85909 5.54979 9.85909 5.02215 10.1845 4.69671C10.51 4.37128 11.0376 4.37128 11.363 4.69671L16.6663 10L11.363 15.3033C11.0376 15.6288 10.51 15.6288 10.1845 15.3033C9.85909 14.9779 9.85909 14.4502 10.1845 14.1248L13.476 10.8333Z" fill="#9E55B5"/></svg>';

                    elm.insertAdjacentElement('beforeend', iconElement);
                };

                if (typeof window.requestAnimationFrame === 'function') {
                    window.requestAnimationFrame(readStyles);
                } else {
                    setTimeout(readStyles, 0);
                }
            } else {
                console.log('🔴 [ADD PARTNER BLOCK] Icon not found and partner_info_modal is disabled');
            }
        });

        if (!skipInitSelectedPartner && typeof initSelectedPartner === 'function') {
            initSelectedPartner();
        }
    } else {
        /* Partner is attached but name/contact must stay hidden — keep shopping-with strip hidden */
        document.querySelectorAll('.partner-container').forEach(elm => elm.classList.add("display-none"));
    }
    if(KROWN.settings.partner_info_modal){
      getPartnerInfoDetails(response);
    }
}

function removePartnerBlock() {
    document.querySelectorAll('.partner-container').forEach(elm => elm.classList.add("display-none"));
    document.querySelectorAll('.partner-info-container').forEach(elm => elm.innerHTML = '');
}

/**
 * Clears register / partner-lookup "selected partner" UI when partner is removed from elsewhere
 * (e.g. header partner-details modal). Safe on pages without partner-referral markup.
 */
function resetPartnerReferralDomAfterPartnerRemoval() {
    const elSelectedPartner = document.getElementById('selected-partner');
    if (elSelectedPartner) {
        elSelectedPartner.innerHTML = '';
    }
    document.querySelectorAll('.partner-referral__container').forEach((container) => {
        const content = container.querySelector('.partner-referral__content');
        const selectedContent = container.querySelector('.partner-referral-selected__content');
        const assignBtnSelected = container.querySelector('.partner-assign-btn--selected');
        if (content) content.classList.remove('hidden');
        if (selectedContent) selectedContent.classList.add('hidden');
        if (assignBtnSelected) assignBtnSelected.classList.add('hidden');
        const partnerList = container.querySelector('#partner-list');
        if (partnerList) partnerList.classList.add('hidden');
    });
}
window.resetPartnerReferralDomAfterPartnerRemoval = resetPartnerReferralDomAfterPartnerRemoval;

/* Cache cart partner ID on page load as a fallback when cookie and localStorage are both unavailable */
let cachedCartPartnerId = null;
(window.JPCartService
  ? window.JPCartService.getCart()
  : fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json()))
  .then(cart => {
    cachedCartPartnerId = cart.attributes?._partner_id || null;
  })
  .catch(() => {});

/* Clear cached cart partner ID when partner is explicitly removed by user */
window.clearCachedCartPartnerId = function() {
  cachedCartPartnerId = null;
};

/* Cookie management functions */
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

function deleteCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999; path=/';
}

function clearPartnerClientStorage() {
    try {
        localStorage.removeItem('partnerInfo');
        deleteCookie('partnerID');
        sessionStorage.removeItem('lastPartner');
    } catch (e) {}
}

/** HTTP 204 from getPartnerForPartnerID — partner not in back office: log + same cleanup as remove partner (strip, cart, URL). */
function applyRemovePartnerAfterPartnerId204(partnerId) {
    console.warn('[Partner] Partner ID not found in back office (HTTP 204).', {
        partnerId: partnerId != null ? String(partnerId).trim() : ''
    });
    clearPartnerClientStorage();
    if (typeof window.clearCachedCartPartnerId === 'function') {
        window.clearCachedCartPartnerId();
    }
    try {
        var u = new URL(window.location.href);
        if (u.searchParams.has('partner')) {
            u.searchParams.delete('partner');
            window.history.replaceState({}, '', u.pathname + u.search + u.hash);
        }
    } catch (e) {}
    removePartnerBlock();
    setHeaderFindPartnerNavVisible(true);
    if (typeof syncPartnerInfoToCartAttributes === 'function') {
        syncPartnerInfoToCartAttributes(null).catch(function () {});
    }
}

/* Function to fetch parter api response and store in localStorage and cookie */
async function fetchPartnerInfo(url, type, id, retryCount) {
    let updatedURL = url + "&" + type + "=" + id
    if (retryCount === 0) return null;

    try {
        const response = await fetch(updatedURL)
        if (!response.ok) {
            return await fetchPartnerInfo(url, type, id, retryCount - 1);
        } else if (response.status === 204) {
            if (type === 'commSysPartnerID') {
                applyRemovePartnerAfterPartnerId204(id);
            }
            return null;
        }
        const responseBody = await response.json();
        if (responseBody.error) {
            return null;
        }
        const toStore = withSessionPartnerAttribution(responseBody);
        localStorage.setItem('partnerInfo', JSON.stringify(toStore));
        setCookie('partnerID', toStore.commSysPartnerID, 180);
        sessionStorage.setItem('lastPartner', toStore.commSysPartnerID);
        window.lastFetchedPartnerDetails = toStore;
        return toStore;
    } catch (error) {
        return await fetchPartnerInfo(url, type, id, retryCount - 1);
    }
}

/**
 * Map app proxy GET /a/api/partners/get-by-shopify-customer `data` object to the shape
 * used across the theme (Exigo-style field names).
 * @param {object} data - API `data` when partner found
 * @returns {object|null}
 */
function normalizePartnerFromAppProxyGetByCustomer(data) {
    if (!data || data.exigoId == null || data.exigoId === '') {
        return null;
    }
    const addr = data.address && typeof data.address === 'object' ? data.address : {};
    return {
        commSysPartnerID: String(data.exigoId),
        FirstName: data.firstName || '',
        LastName: data.lastName || '',
        hide_partner_info: data.isInternalAccount ? 'Yes' : 'No',
        webAlias: data.webAlias || '',
        Email: addr.email || '',
        Phone: addr.phone || '',
        WebsiteURL: '',
        [PARTNER_ATTRIBUTION_KEY]: PARTNER_ATTRIBUTION_SHOPIFY_ACCOUNT
    };
}

/**
 * Logged-in partner lookup via Shopify app proxy (single request, no retries).
 * The proxy identifies the customer from Shopify's signed query, so nothing is sent.
 * Persists to localStorage, partnerID cookie, and sessionStorage lastPartner on success.
 * @param {string|number} shopifyCustomerId - Logged-in customer id; the lookup is skipped without one
 * @returns {Promise<object|null>} Normalized partner object or null
 */
async function fetchPartnerByShopifyCustomer(shopifyCustomerId) {
    const id = shopifyCustomerId != null ? String(shopifyCustomerId).trim() : '';
    if (!id) {
        return null;
    }
    const url = '/a/api/partners/get-by-shopify-customer';
    try {
        const response = await fetch(url);
        if (!response.ok) {
            return null;
        }
        const body = await response.json();
        const data = body && body.data;
        if (!data) {
            return null;
        }
        const normalized = normalizePartnerFromAppProxyGetByCustomer(data);
        if (!normalized) {
            return null;
        }
        localStorage.setItem('partnerInfo', JSON.stringify(normalized));
        setCookie('partnerID', normalized.commSysPartnerID, 180);
        sessionStorage.setItem('lastPartner', normalized.commSysPartnerID);
        return normalized;
    } catch (error) {
        return null;
    }
}

/**
 * When get-by-shopify-customer returns no partner, resolve guest attribution in order:
 * cookie → localStorage → cart (each ID is expanded via get_partner_by_partner_id when possible).
 */
async function resolvePartnerFallbackCookieThenLsThenCart(retryCount) {
  const tryFetchById = async (id) => {
    if (id == null || !String(id).trim()) return null;
    return fetchPartnerInfo(
      KROWN.settings.partner.get_partner_by_partner_id_url,
      'commSysPartnerID',
      String(id).trim(),
      retryCount
    );
  };

  const cookieId = getCookie('partnerID');
  if (cookieId) {
    const fromCookie = await tryFetchById(cookieId);
    if (fromCookie) return fromCookie;
  }

  try {
    const raw = localStorage.getItem('partnerInfo');
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && parsed.commSysPartnerID) {
        if (parsed.FirstName != null || parsed.LastName != null) {
          return parsed;
        }
        const fromLs = await tryFetchById(parsed.commSysPartnerID);
        if (fromLs) return fromLs;
        /* 204 clears storage in fetchPartnerInfo; do not return stale ID-only object */
        return null;
      }
    }
  } catch (e) {}

  try {
    const cartRoot = typeof Shopify !== 'undefined' && Shopify.routes?.root ? Shopify.routes.root : '/';
    const cart = window.JPCartService
      ? await window.JPCartService.getCart()
      : await (await fetch(`${cartRoot}cart.js`, { credentials: 'same-origin' })).json();
    const cartPartnerId = cart.attributes?._partner_id;
    if (cartPartnerId) {
      console.log('***** PARTNER INIT: Logged-in user - recovering partner from cart:', cartPartnerId, '*****');
      const fromCart = await tryFetchById(cartPartnerId);
      if (fromCart) return fromCart;
    }
  } catch (e) {}

  return null;
}

/* Get partner information from local storage or cookie */
function getPartnerDetailsFromLocalStorage() {
    let partnerLocalDetails = localStorage.getItem('partnerInfo');
    if (!partnerLocalDetails) {
        // If not in localStorage, try to get from cookie (now just the ID)
        const partnerID = getCookie('partnerID');
        if (partnerID) {
            // If we have the ID, we could optionally fetch the full info here if needed
            // For now, just return an object with the ID
            return { commSysPartnerID: partnerID };
        }
    }
    
    if (partnerLocalDetails && partnerLocalDetails !== null) {
        try {
            const parsedInfo = JSON.parse(partnerLocalDetails);
            // If localStorage has the partner but cookie is missing, restore it
            if (parsedInfo?.commSysPartnerID && !getCookie('partnerID')) {
                setCookie('partnerID', parsedInfo.commSysPartnerID, 180);
            }
            return parsedInfo;
        } catch (error) {
            console.log('Failed to parse partner storage data' + error);
        }
    } else {
        document.querySelectorAll('.partner-container').forEach(function(element) {
            element.classList.add("display-none");
        });
    }
    return null;
}

function getUrlParams() {
    let urlParams = new URLSearchParams(window.location.search);
    const isFromCheckout = urlParams.has('checkout_url');
    if (isFromCheckout) {
        // If partner/partnerAlias is already in the current URL (e.g. appended by Cloudflare),
        // use those directly rather than overwriting with checkout URL params
        if (urlParams.has('partner') || urlParams.has('partnerAlias')) {
            return urlParams;
        }
        const checkoutUrlEncoded = getCheckoutUrl();
        const urlDecoded = decodeURIComponent(checkoutUrlEncoded);
        urlParams = new URLSearchParams(urlDecoded.split('?')[1]);
    }
    return urlParams;
}

function getAssociatedPartnerId() {
    const cookieId = getCookie('partnerID');
    if (cookieId) return cookieId;
    // Fallback to localStorage when cookie is unavailable (e.g. cookie consent not yet accepted)
    try {
        const partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'));
        if (partnerInfo?.commSysPartnerID) return partnerInfo.commSysPartnerID;
    } catch (e) {}
    // Fallback to cached cart attributes when both cookie and localStorage are unavailable
    if (cachedCartPartnerId) return cachedCartPartnerId;
    return '';
}

/**
 * Sync partner info (id, name, hide_partner_info) to cart attributes.
 * Call when partner is set, updated, or removed.
 * @param {string|object|null} partnerIdOrDetails - Partner ID string, full partner details object from getPartnerForPartnerID API, or null to clear.
 */
const PARTNER_CHECKOUT_FLAG = '_partner_set_in_checkout';
const GLOBAL_PARTNER_SEARCH_ATTR = '_global_partner_search';

function cartUpdateUrl() {
    const root = typeof Shopify !== 'undefined' && Shopify.routes?.root ? Shopify.routes.root : '/';
    return `${root}cart/update.js`;
}

async function fetchCartJson() {
    try {
        if (window.JPCartService) {
            return await window.JPCartService.getCart({ force: true }).catch(() => null);
        }
        const root = typeof Shopify !== 'undefined' && Shopify.routes?.root ? Shopify.routes.root : '/';
        const response = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' }
        });
        if (!response.ok) {
            return null;
        }
        return response.json();
    } catch (error) {
        console.error('Error fetching cart:', error);
        return null;
    }
}

function isPartnerCheckoutFlagTruthy(value) {
    if (value === true) {
        return true;
    }
    if (typeof value === 'string' && value.toLowerCase() === 'true') {
        return true;
    }
    return false;
}

async function clearPartnerCheckoutFlagOnCart() {
    const attributes = {
        [PARTNER_CHECKOUT_FLAG]: '',
        [GLOBAL_PARTNER_SEARCH_ATTR]: ''
    };

    try {
        if (window.JPCartService) {
            // Serialised against every other cart write, so a concurrent write
            // can't clobber these attributes. The service waits on the
            // shared-cart restore gate itself.
            await window.JPCartService.update({ attributes });
            return;
        }

        if (typeof window.awaitSharedCartRestore === 'function') {
            await window.awaitSharedCartRestore();
        }
        const response = await fetch(cartUpdateUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({ attributes })
        });
        if (!response.ok) {
            console.error('Failed to clear partner checkout flag:', response.statusText);
        }
    } catch (error) {
        console.error('Error clearing partner checkout flag:', error);
    }
}

async function syncPartnerInfoToCartAttributes(partnerIdOrDetails) {
    var attributes = {
        _partner_id: '',
        _partner_name: '',
        _hide_partner_info: '',
        [PARTNER_CHECKOUT_FLAG]: '',
        [GLOBAL_PARTNER_SEARCH_ATTR]: ''
    };

    var updateCart = async function(attrs) {
        try {
            if (window.JPCartService) {
                // Serialised against every other cart write — partner attribution
                // is the thing most likely to be lost to a racing write. The
                // service waits on the shared-cart restore gate itself.
                await window.JPCartService.update({ attributes: attrs });
                return;
            }

            if (typeof window.awaitSharedCartRestore === 'function') {
                await window.awaitSharedCartRestore();
            }
            const response = await fetch(cartUpdateUrl(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                },
                body: JSON.stringify({ attributes: attrs })
            });
            if (!response.ok) {
                console.error('Failed to update cart partner attributes:', response.statusText);
            }
        } catch (error) {
            console.error('Error updating cart partner attributes:', error);
        }
    };

    if (!partnerIdOrDetails) {
        await updateCart(attributes);
        return;
    }

    var partnerDetails = null;
    if (typeof partnerIdOrDetails === 'object' && partnerIdOrDetails.commSysPartnerID) {
        partnerDetails = partnerIdOrDetails;
    } else if (typeof partnerIdOrDetails === 'string') {
        partnerDetails = await fetchPartnerInfo(
            KROWN.settings.partner.get_partner_by_partner_id_url,
            'commSysPartnerID',
            partnerIdOrDetails,
            1
        );
    }

    if (partnerDetails) {
        var partnerName = [partnerDetails.FirstName, partnerDetails.LastName].filter(Boolean).map(capitalizeName).join(' ') || '';
        attributes._partner_id = String(partnerDetails.commSysPartnerID ?? '');
        attributes._partner_name = partnerName;
        attributes._hide_partner_info = partnerDetails.hide_partner_info || '';
        attributes.WasLeadPoolSelected = '';  // only clear when partner is set (attribution or lookup)
        await updateCart(attributes);
    } else {
        await updateCart(attributes);
    }
}

function syncAssociatedPartnerFromCookie() {
    const partnerId = getAssociatedPartnerId();
    if (!partnerId) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('partner') !== partnerId) {
        url.searchParams.set('partner', partnerId);
        window.history.replaceState({}, '', url.toString());
    }
}

window.partnerInitialized = false;
window.shopifyAccountPartnerResolved = false;
window.hasShopifyAccountAttachedPartner = false;

const announceShopifyAccountPartnerResolved = (attached) => {
  if (window.shopifyAccountPartnerResolved) return;
  window.hasShopifyAccountAttachedPartner = !!attached;
  window.shopifyAccountPartnerResolved = true;
  document.dispatchEvent(new CustomEvent('shopifyAccountPartnerResolved'));
};

const readAnnouncedSharedCartSharePartnerId = () => {
  try {
    if (!new URLSearchParams(window.location.search).has('cart_token')) return '';
    return String(
      window.sharedCartSharePartnerId || sessionStorage.getItem('sharedCartPartnerId') || ''
    ).trim();
  } catch (e) {
    return String(window.sharedCartSharePartnerId || '').trim();
  }
};

const awaitSharedCartRestoreIfPresent = async () => {
  if (!new URLSearchParams(window.location.search).has('cart_token')) return;
  if (typeof window.awaitSharedCartRestore !== 'function') return;
  await window.awaitSharedCartRestore();
};

const initPartner = async () => {
  try {
  const retryCount = 1;
  const isLoggedIn = !!KROWN.customerId;
  const urlParams = getUrlParams();
  const commSysPartnerIdParam = urlParams.get('partner');
  const partnerAliasParam = urlParams.get('partnerAlias');

  await awaitSharedCartRestoreIfPresent();
  const sharedCartSharePartnerId = readAnnouncedSharedCartSharePartnerId();

  let partnerDetails = null;
  /** True only when this init's `fetchPartnerByShopifyCustomer` returned a partner (not LS/cookie fallback). */
  let loggedInPartnerFromShopifyCustomerApiThisInit = false;

  const cleanUpUrlParams = (paramsToDelete = []) => {
    const url = new URL(window.location.href);
    paramsToDelete.forEach(param => url.searchParams.delete(param));
    window.history.replaceState({}, '', url.toString());
  };

  const setPartnerParamInUrl = (partnerId) => {
    const url = new URL(window.location.href);
    url.searchParams.set('partner', partnerId);
    window.history.replaceState({}, '', url.toString());
  };

  const cartJson = await fetchCartJson();
  let appliedCheckoutCartPartner = false;
  if (cartJson?.attributes && isPartnerCheckoutFlagTruthy(cartJson.attributes[PARTNER_CHECKOUT_FLAG])) {
    appliedCheckoutCartPartner = true;
    const cartPartnerId = String(cartJson.attributes._partner_id || '').trim();
    if (cartPartnerId) {
      let details = await fetchPartnerInfo(
        KROWN.settings.partner.get_partner_by_partner_id_url,
        'commSysPartnerID',
        cartPartnerId,
        retryCount
      );
      if (!details) {
        const nameFromCart = String(cartJson.attributes._partner_name || '').trim();
        const nameParts = nameFromCart ? nameFromCart.split(/\s+/) : [];
        details = withSessionPartnerAttribution({
          commSysPartnerID: cartPartnerId,
          FirstName: nameParts[0] || '',
          LastName: nameParts.slice(1).join(' ') || '',
          hide_partner_info: cartJson.attributes._hide_partner_info || ''
        });
        localStorage.setItem('partnerInfo', JSON.stringify(details));
        setCookie('partnerID', cartPartnerId, 180);
        sessionStorage.setItem('lastPartner', cartPartnerId);
      }
      partnerDetails = details;
      setPartnerParamInUrl(cartPartnerId);
    } else {
      localStorage.removeItem('partnerInfo');
      deleteCookie('partnerID');
      sessionStorage.removeItem('lastPartner');
      cleanUpUrlParams(['partner']);
      partnerDetails = null;
    }
    await clearPartnerCheckoutFlagOnCart();
  }

  if (!isLoggedIn) {
    announceShopifyAccountPartnerResolved(false);
  }

  if (!appliedCheckoutCartPartner) {
  if (isLoggedIn) {
    if (partnerAliasParam) cleanUpUrlParams(['partnerAlias']);

    if (KROWN.customerId) {
      partnerDetails = await fetchPartnerByShopifyCustomer(KROWN.customerId);
      if (partnerDetails) {
        loggedInPartnerFromShopifyCustomerApiThisInit = true;
        syncAssociatedPartnerFromCookie();
      }
    } else {
      partnerDetails = null;
    }
    announceShopifyAccountPartnerResolved(loggedInPartnerFromShopifyCustomerApiThisInit);

    if (!partnerDetails && window.sessionStorage.getItem('customerRegistrationSession') === 'true') {
      partnerDetails = getPartnerDetailsFromLocalStorage();
    }

    // Shared cart, not account-attached: adopt the sharer (including lookup Mell).
    // Account-attached already has partnerDetails and never enters this branch.
    if (!partnerDetails && sharedCartSharePartnerId) {
      setCookie('partnerID', sharedCartSharePartnerId, 180);
      partnerDetails = await fetchPartnerInfo(
        KROWN.settings.partner.get_partner_by_partner_id_url,
        'commSysPartnerID',
        sharedCartSharePartnerId,
        retryCount
      );
      if (partnerDetails) {
        setPartnerParamInUrl(partnerDetails.commSysPartnerID);
      }
    } else if (!partnerDetails && commSysPartnerIdParam) {
      setCookie('partnerID', commSysPartnerIdParam, 180);
      partnerDetails = await fetchPartnerInfo(
        KROWN.settings.partner.get_partner_by_partner_id_url,
        'commSysPartnerID',
        commSysPartnerIdParam,
        retryCount
      );
      if (partnerDetails) {
        setPartnerParamInUrl(partnerDetails.commSysPartnerID);
      }
    }

    // If get-by-shopify-customer returned no partner: cookie → localStorage → cart.
    if (!partnerDetails) {
      partnerDetails = await resolvePartnerFallbackCookieThenLsThenCart(retryCount);
    }
  } else if (sharedCartSharePartnerId) {
    setCookie('partnerID', sharedCartSharePartnerId, 180);
    partnerDetails = await fetchPartnerInfo(
      KROWN.settings.partner.get_partner_by_partner_id_url,
      'commSysPartnerID',
      sharedCartSharePartnerId,
      retryCount
    );
    if (partnerDetails) {
      setPartnerParamInUrl(partnerDetails.commSysPartnerID);
    }
  } else if (partnerAliasParam) {
    cleanUpUrlParams(['partnerAlias', 'partner']);

    partnerDetails = await fetchPartnerInfo(
      KROWN.settings.partner.get_partner_by_web_alias_url,
      'webAlias',
      partnerAliasParam,
      retryCount
    );

    if (partnerDetails) {
      setPartnerParamInUrl(partnerDetails.commSysPartnerID);
    }
  } else if (commSysPartnerIdParam) {
    let lastPartnerID = sessionStorage.getItem('lastPartner');
    // ECOM-768: sessionStorage is per-tab. Seed from shared cookie/localStorage so
    // house-vs-normal protection still runs when a new tab opens with ?partner=.
    if (!lastPartnerID) {
      const sharedPartnerId = String(getAssociatedPartnerId() || '').trim();
      if (sharedPartnerId) {
        sessionStorage.setItem('lastPartner', sharedPartnerId);
        lastPartnerID = sharedPartnerId;
      }
    }
    if (lastPartnerID && commSysPartnerIdParam !== lastPartnerID) {
      // Check if current partner has hide_partner_info set to "no"
      const currentPartnerInfo = getPartnerDetailsFromLocalStorage();
      if (currentPartnerInfo && currentPartnerInfo.hide_partner_info === "No") {
        // Current partner doesn't hide info, check if new partner hides info
        const newPartnerDetails = await fetchPartnerInfo(
          KROWN.settings.partner.get_partner_by_partner_id_url,
          'commSysPartnerID',
          commSysPartnerIdParam,
          retryCount
        );
        
        if (newPartnerDetails && newPartnerDetails.hide_partner_info === "Yes" && currentPartnerInfo.hide_partner_info === "No") {
          // New partner hides info AND current partner doesn't hide info - keep current partner
          partnerDetails = currentPartnerInfo;
          // Update storage to reflect current partner
          localStorage.setItem('partnerInfo', JSON.stringify(currentPartnerInfo));
          setCookie('partnerID', currentPartnerInfo.commSysPartnerID, 180);
          sessionStorage.setItem('lastPartner', currentPartnerInfo.commSysPartnerID);
          // Revert URL to current partner ID
          setPartnerParamInUrl(currentPartnerInfo.commSysPartnerID);
        } else if (newPartnerDetails) {
          // New partner exists and either doesn't hide info OR both partners hide info - update to new partner
          partnerDetails = newPartnerDetails;
        } else {
          // New partner doesn't exist (null/undefined), keep current partner
          partnerDetails = currentPartnerInfo;
          // Update storage to reflect current partner
          localStorage.setItem('partnerInfo', JSON.stringify(currentPartnerInfo));
          setCookie('partnerID', currentPartnerInfo.commSysPartnerID, 180);
          sessionStorage.setItem('lastPartner', currentPartnerInfo.commSysPartnerID);
          // Revert URL to current partner ID
          setPartnerParamInUrl(currentPartnerInfo.commSysPartnerID);
        }
      } else {
        // Current partner hides info or doesn't exist, proceed with new partner
        localStorage.removeItem('partnerInfo');
        const newPartnerDetails = await fetchPartnerInfo(
          KROWN.settings.partner.get_partner_by_partner_id_url,
          'commSysPartnerID',
          commSysPartnerIdParam,
          retryCount
        );
        
        if (newPartnerDetails) {
          // New partner exists, check if it hides info AND current partner shows info
          if (newPartnerDetails.hide_partner_info === "Yes" && currentPartnerInfo?.hide_partner_info === "No") {
            partnerDetails = currentPartnerInfo;
            // Update storage to reflect current partner
            if (currentPartnerInfo?.commSysPartnerID) {
              localStorage.setItem('partnerInfo', JSON.stringify(currentPartnerInfo));
              setCookie('partnerID', currentPartnerInfo.commSysPartnerID, 180);
              sessionStorage.setItem('lastPartner', currentPartnerInfo.commSysPartnerID);
            }
            // Revert URL to current partner ID if it exists
            if (currentPartnerInfo?.commSysPartnerID) {
              setPartnerParamInUrl(currentPartnerInfo.commSysPartnerID);
            }
          } else {
            partnerDetails = newPartnerDetails;
          }
        } else {
          // New partner doesn't exist, keep current partner if it exists
          partnerDetails = currentPartnerInfo;
          // Update storage to reflect current partner
          if (currentPartnerInfo?.commSysPartnerID) {
            localStorage.setItem('partnerInfo', JSON.stringify(currentPartnerInfo));
            setCookie('partnerID', currentPartnerInfo.commSysPartnerID, 180);
            sessionStorage.setItem('lastPartner', currentPartnerInfo.commSysPartnerID);
          }
          // Revert URL to current partner ID if it exists
          if (currentPartnerInfo?.commSysPartnerID) {
            setPartnerParamInUrl(currentPartnerInfo.commSysPartnerID);
          }
        }
      }
    } else {
      // No previous partner or same partner.
      // Set cookie immediately from URL param so Cloudflare can append ?partner= on any
      // navigation that happens before fetchPartnerInfo resolves (race condition fix).
      setCookie('partnerID', commSysPartnerIdParam, 180);
      partnerDetails = await fetchPartnerInfo(
        KROWN.settings.partner.get_partner_by_partner_id_url,
        'commSysPartnerID',
        commSysPartnerIdParam,
        retryCount
      );
    }
  } else {
    partnerDetails = getPartnerDetailsFromLocalStorage();
    if(partnerDetails){
      syncAssociatedPartnerFromCookie();
      // If we only have the partner ID (no name), fetch full details.
      if (partnerDetails.commSysPartnerID && !partnerDetails.FirstName) {
        const fullDetails = await fetchPartnerInfo(
          KROWN.settings.partner.get_partner_by_partner_id_url,
          'commSysPartnerID',
          partnerDetails.commSysPartnerID,
          retryCount
        );
        if (fullDetails) {
          partnerDetails = fullDetails;
        } else {
          partnerDetails = null;
        }
      }
    } else {
      console.log('***** PARTNER INIT: No partner found in localStorage *****');
      // Before clearing cart, check if cart already has a valid partner (e.g. Safari ITP cleared localStorage but cart session persists)
      try {
        const cart = window.JPCartService
          ? await window.JPCartService.getCart()
          : await (await fetch((typeof Shopify !== 'undefined' && Shopify.routes?.root) ? Shopify.routes.root + 'cart.js' : '/cart.js', { credentials: 'same-origin' })).json();
        const cartPartnerId = cart.attributes?._partner_id;
        if (cartPartnerId) {
          console.log('***** PARTNER INIT: Recovering partner from cart attributes:', cartPartnerId, '*****');
          // Restore to localStorage and cookie from cart
          const recoveredDetails = await fetchPartnerInfo(
            KROWN.settings.partner.get_partner_by_partner_id_url,
            'commSysPartnerID',
            cartPartnerId,
            retryCount
          );
          if (recoveredDetails) {
            partnerDetails = recoveredDetails;
          }
        }
      } catch (e) {
        console.log('***** PARTNER INIT: Failed to check cart for partner:', e, '*****');
      }
    }
  }
  }

  await syncPartnerInfoToCartAttributes(partnerDetails);

  if (typeof window.updateLeadPoolAssignUI === 'function') {
    window.updateLeadPoolAssignUI();
  }

  const renderBlock = () => {
    partnerDetails ? addPartnerBlock(partnerDetails) : removePartnerBlock();
    /**
     * Logged-in header "Find a Partner":
     * - get-by-shopify-customer returned a partner this load → hide lookup. addPartnerBlock shows YASW
     *   when hide_partner_info !== "Yes", else strip stays hidden (internal).
     * - API returned nothing; partner from cookie/LS/cart (same resolution as guests) → same lookup
     *   rule as guests: hide lookup when strip shows a named partner (hide !== "Yes"); show lookup when
     *   internal-only (hide === "Yes") so they can change partner without duplicating YASW + link.
     */
    let showPartnerLookupLink;
    if (!isLoggedIn) {
      showPartnerLookupLink =
        !partnerDetails || partnerDetails.hide_partner_info === 'Yes';
    } else if (!partnerDetails) {
      showPartnerLookupLink = true;
    } else if (loggedInPartnerFromShopifyCustomerApiThisInit) {
      showPartnerLookupLink = false;
    } else {
      showPartnerLookupLink = partnerDetails.hide_partner_info === 'Yes';
    }
    setHeaderFindPartnerNavVisible(showPartnerLookupLink);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderBlock);
  } else {
    renderBlock();
  }
  } finally {
    window.partnerInitialized = true;
    document.dispatchEvent(new CustomEvent('partnerInitialized'));
  }
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelector('.customer-logout')?.addEventListener('click', () => {
    sessionStorage.removeItem("customerRegistrationSession");
  });
  setupPartnerInfoModalOpenInteraction();
});

/**
 * Open partner info modal from the header/sidebar partner row.
 * Uses event delegation so it still works when the arrow icon is inserted in a
 * requestAnimationFrame after assign (getPartnerInfoDetails used to bind to
 * #headerPartnerModalDisplay before that node existed).
 */
function setupPartnerInfoModalOpenInteraction() {
  if (typeof window === "undefined" || window.__partnerInfoModalOpenDelegationBound) {
    return;
  }
  const modalOverlay = document.getElementById("headerPartnerInfoModalOverlay");
  if (!modalOverlay) {
    return;
  }

  const headerBlurPartnerInfo = document.querySelector(".shopify-section-group-header-group");

  document.addEventListener("click", function partnerInfoModalOpenDelegator(e) {
    if (!window.KROWN || !KROWN.settings || !KROWN.settings.partner_info_modal) {
      return;
    }

    const fromBg = e.target.closest(".partner-container .bg-partner-info");
    const fromIcon = e.target.closest(".partner-container .partner-market-icon");
    const fromFooterPartner = e.target.closest("#footerSideBarPartnerModalDisplay");
    const fromCartWelcome = e.target.closest("[data-cart-v2-partner-modal]");

    let row = null;
    if (fromBg || fromIcon) {
      row = (fromBg || fromIcon).closest(".partner-container");
    } else if (fromFooterPartner) {
      row = fromFooterPartner.closest(".partner-container");
    }

    if (!fromCartWelcome && (!row || row.classList.contains("display-none"))) {
      return;
    }

    e.preventDefault();
    modalOverlay.style.display = "flex";
    document.body.classList.add("header-partner-info-body-overflow");
    if (headerBlurPartnerInfo) {
      headerBlurPartnerInfo.classList.add("header-partner-info-header-blur");
    }
  });

  window.__partnerInfoModalOpenDelegationBound = true;
}

function getPartnerInfoDetails(response) {
  const firstName = response.FirstName;
  const lastName = response.LastName;
  const email = response.Email;
  const phone = response.Phone;
  const link = response.WebsiteURL;
  const partnerImage = response?.Image;
  const contactUsUrl = KROWN.settings.routes.contact_us;
  const contactUs = document.getElementById("partner-info-contact-us")
  const selectedlocale = localStorage.getItem("selectedLanguage");
  const partnerInfoModalCloseButton = document.querySelector(".header-partner-info-modal-box-header-btn")
  const accountContainer = document.querySelector('#site-header a.area--account');
  const isLoggedInFromHeader = accountContainer ? accountContainer.getAttribute('data-logged-in') === 'true' : false;
  const isLoggedIn = isLoggedInFromHeader || !!KROWN.customerId;
  const removeSection = document.querySelector(".header-partner-info-modal-box-remove");

  if (removeSection) {
    // Guests: always show Change partner. Logged-in: show unless partner came only from
    // get-by-shopify-customer (Exigo account link); session/lookup/cart/URL attribution keeps CTA so they can reopen lookup.
    const attribution = getPartnerAttributionSource(response);
    const hideChangePartner =
      isLoggedIn && attribution === PARTNER_ATTRIBUTION_SHOPIFY_ACCOUNT;
    removeSection.classList.toggle("display-none", hideChangePartner);
  }

  if(contactUs){
    contactUs.href = contactUsUrl;
  }
  
  if (partnerImage) {
    document.getElementById("partner-info-image").innerHTML = `<img class="header-partner-info-modal-box-body-img" src="${partnerImage}"/>`;
  }
  
  document.getElementById("partnerFullName").innerHTML = `${capitalizeName(firstName)} ${capitalizeName(lastName)}`;

  if (phone && phone != "") {
    document.getElementById("header-partner-info-phone").innerHTML = phone;
    document.getElementById("partnerInfoMobileIcon").classList.remove("display-none");
    
    document.querySelector(".partner-info-mobile-call-function").addEventListener("click", function () {
      const isMobile = window.matchMedia("(max-width:768px)").matches;
      if(isMobile){
        window.location.href = `tel:${phone}`;
      }
    });
  }

  if (email && email != "") {
    document.getElementById("header-partner-info-mail").innerHTML = email;
    document.getElementById("partnerInfoEmailIcon").classList.remove("display-none");
    document.querySelector(".partner-info-mobile-email-function").addEventListener("click", function () {
      const isMobile = window.matchMedia("(max-width:768px)").matches;
      if(isMobile){
        window.location.href = `mailto:${email}`;
      }
    });
  }

  // Construct partner link using current page URL and partner ID
  const partnerId = response.commSysPartnerID;
  if (partnerId) {
    // Function to get current page URL with partner parameter
    function getPartnerLink() {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('partner', partnerId);
      return currentUrl.toString();
    }
    
    // Set href to current page with partner parameter
    const partnerLink = getPartnerLink();
    document.getElementById("header-partner-info-link").href = partnerLink;
    document.getElementById("partnerInfoLinkIcon").classList.remove("display-none");
    document.getElementById("header-partner-info-link").addEventListener('click', function(event) {
      event.preventDefault();
      // Get the current URL with partner parameter (in case user navigated to a different page)
      const linkToCopy = getPartnerLink();
      navigator.clipboard.writeText(linkToCopy).then(function() {
        showLinkCopiedToast(true)
        partnerInfoModalCloseButton.classList.add("display-none")
      }).catch(function(err) {
        console.error('The link is unavailable');
      });
    });
  }

  if(selectedlocale == 'Hebrew'){
    partnerInfoModalCloseButton.classList.add("header-partner-info-modal-box-header-btn-isl");
  }

  setupPartnerInfoModalOpenInteraction();

  const modalOverlay = document.getElementById("headerPartnerInfoModalOverlay");
  const headerBlurPartnerInfo = document.querySelector(".shopify-section-group-header-group");

  const closeModal = document.getElementById("headerClosePartnerModal");
  if (closeModal && modalOverlay) {
    closeModal.addEventListener("click", function () {
      modalOverlay.style.display = "none";
      document.body.classList.remove("header-partner-info-body-overflow");
      if (headerBlurPartnerInfo) {
        headerBlurPartnerInfo.classList.remove("header-partner-info-header-blur");
      }
    });
  }

  document.getElementById("partner-modal-toast-close").addEventListener("click", function () {
    showLinkCopiedToast()
    partnerInfoModalCloseButton.classList.remove("display-none")
  });
}

function showLinkCopiedToast(showToast=false) {
  const toastMessageEl = document.getElementById("partner-modal-toast-message");
  if(showToast) {   
    document.querySelector(".header-partner-info-modal-box-header-btn").classList.remove("display-none")
    toastMessageEl.classList.remove("display-none");
  } else {
    toastMessageEl.classList.add("display-none")
  }
}

if (typeof window !== 'undefined') {
  window.syncPartnerInfoToCartAttributes =
    window.syncPartnerInfoToCartAttributes || syncPartnerInfoToCartAttributes;
  window.fetchPartnerByShopifyCustomer =
    window.fetchPartnerByShopifyCustomer || fetchPartnerByShopifyCustomer;
  window.withSessionPartnerAttribution = withSessionPartnerAttribution;
  window.setHeaderFindPartnerNavVisible = setHeaderFindPartnerNavVisible;
  window.emitPartnerAnalytics = window.emitPartnerAnalytics || emitPartnerAnalytics;
}

/**
 * Guest checkout: if cart has _partnerFeeProduct attribute, send shoppers to login first.
 */
(function initPartnerFeeCheckoutLoginGate() {
  if (typeof document === 'undefined' || window.__partnerFeeCheckoutGateBound) {
    return;
  }
  window.__partnerFeeCheckoutGateBound = true;

  function isShopifyCustomerLoggedIn() {
    if (typeof KROWN === 'undefined' || KROWN.customerId == null) {
      return false;
    }
    return String(KROWN.customerId).trim() !== '';
  }

  function cartHasPartnerFeeCheckoutGateAttribute(cart) {
    const attrs = cart && cart.attributes;
    if (!attrs || typeof attrs !== 'object') {
      return false;
    }
    const v = attrs._partnerFeeProduct;
    return v != null && String(v).trim() !== '';
  }

  /** e.g. /en or /en-US from pathname */
  function getLocalePrefixFromPathname(pathname) {
    const m = /^\/([a-z]{2}(?:-[A-Z]{2})?)(?=\/|$)/.exec(pathname || '');
    return m ? `/${m[1]}` : '';
  }

  function mergeLocaleIntoPath(pathname, localePrefix) {
    if (!localePrefix) {
      return pathname.startsWith('/') ? pathname : `/${pathname}`;
    }
    const p = pathname.startsWith('/') ? pathname : `/${pathname}`;
    if (p === localePrefix || p.startsWith(`${localePrefix}/`)) {
      return p;
    }
    return `${localePrefix}${p}`;
  }

  /**
   * Guest redirect: locale-prefixed login + checkout_url (full URL) for post-login return.
   * Keeps ?locale= from the current page when present (Markets).
   */
  function buildPartnerFeeGuestLoginRedirectUrl() {
    const routes = typeof KROWN !== 'undefined' && KROWN.settings && KROWN.settings.routes;
    const baseLogin = routes && routes.account_login_url ? routes.account_login_url : '/account/login';
    const login = new URL(baseLogin, window.location.origin);
    const localePrefix = getLocalePrefixFromPathname(window.location.pathname);
    login.pathname = mergeLocaleIntoPath(login.pathname, localePrefix);

    const checkoutPath = mergeLocaleIntoPath('/checkout', localePrefix);
    const checkoutFull = new URL(checkoutPath, window.location.origin).href;
    login.searchParams.set('checkout_url', checkoutFull);

    const cur = new URLSearchParams(window.location.search);
    if (cur.has('locale')) {
      login.searchParams.set('locale', cur.get('locale'));
    }

    return login.href;
  }

  document.addEventListener(
    'submit',
    async function partnerFeeCheckoutGate(ev) {
      if (window.__partnerFeeGateBypass) {
        window.__partnerFeeGateBypass = false;
        return;
      }
      const form = ev.target;
      if (!form || form.id !== 'cart') {
        return;
      }
      const sub = ev.submitter;
      if (sub && sub.getAttribute('name') !== 'checkout') {
        return;
      }
      if (!sub) {
        const ae = document.activeElement;
        if (!ae || ae.getAttribute('name') !== 'checkout') {
          return;
        }
      }
      if (isShopifyCustomerLoggedIn()) {
        return;
      }

      ev.preventDefault();
      ev.stopPropagation();

      const submitter = sub || document.activeElement;
      let cart;
      try {
        // force: this gates checkout on a cart attribute, so it must read the
        // live cart rather than a cached copy.
        if (window.JPCartService) {
          cart = await window.JPCartService.getCart({ force: true });
        } else {
          const root = typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
          const cartUrl = root.replace(/\/?$/, '/') + 'cart.js';
          const r = await fetch(cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          cart = await r.json();
        }
      } catch (e) {
        window.__partnerFeeGateBypass = true;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitter);
        } else {
          form.submit();
        }
        return;
      }
      if (!cartHasPartnerFeeCheckoutGateAttribute(cart)) {
        window.__partnerFeeGateBypass = true;
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(submitter);
        } else {
          form.submit();
        }
        return;
      }
      try {
        localStorage.setItem('redirect_checkout', 'true');
        localStorage.setItem('redirect_checkout_purchase_banner', 'true');
      } catch (err) {
        /* ignore */
      }
      window.location.href = buildPartnerFeeGuestLoginRedirectUrl();
    },
    true
  );
})();